"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAllowedTypes = extractAllowedTypes;
exports.extractAllowedSchemas = extractAllowedSchemas;
const schema_1 = require("../schema");
function extractAllowedTypes(application) {
    const allowedTypes = [];
    Object.keys(schema_1.SearchSchema).forEach((key) => {
        schema_1.SearchSchema[key].applications.includes(application) &&
            !schema_1.SearchSchema[key].disabled &&
            allowedTypes.push(key);
    });
    return allowedTypes;
}
function extractAllowedSchemas(application) {
    const allowedTypes = [];
    Object.keys(schema_1.SearchSchema).forEach((key) => {
        schema_1.SearchSchema[key].applications.includes(application) &&
            !schema_1.SearchSchema[key].disabled &&
            allowedTypes.push(schema_1.SearchSchema[key]);
    });
    return allowedTypes;
}
//# sourceMappingURL=extract-appropriate-types.js.map